export const ADD_KITCHEN_TABLE = "ADD_KITCHEN_TABLE"
export const REMOVE_KITCHEN_TABLE = "REMOVE_KITCHEN_TABLE"
export const FETCH_KITCHEN_TABLES = "FETCH_KITCHEN_TABLES"
export const EDIT_KITCHEN_TABLE = "EDIT_KITCHEN_TABLE"